import LeftRightInfo, { LeftRightProps } from './LeftRightInfo';

export type { LeftRightProps };
export default LeftRightInfo;
